import { Component, OnInit, Input } from '@angular/core';
import { WebsiteModel } from '../../../portal.model';

@Component({
  selector: 'app-templates-carousell',
  templateUrl: './templates-carousell.component.html',
  styleUrls: ['./templates-carousell.component.css']
})
export class TemplatesCarousellComponent implements OnInit {
  @Input() website: WebsiteModel
  constructor() { }

  ngOnInit() {
  }

}
